import React, { useContext, useState, useEffect } from 'react';
import { AccountContext } from '../AccountContext';
import { useAccountIdContext } from '../AccountIdContext';

export default function BNPLDeferredInterestTransaction() {
    const termDurations = [3, 6, 9, 12];

    const { accountId, transactionService, interestService, setError } = useContext(AccountContext);
    const [bnplDeferredInterestCreating, setBNPLDeferredInterestCreating] = useState(false as boolean);
    const [amount, setAmount] = useState(0.0);
    const [termDuration, setTermDuration] = useState(termDurations[0]);
    const [hasBNPLDeferredInterestRate, setHasBNPLDeferredInterestRate] = useState<boolean | null>(null);

    const { billingDate } = useAccountIdContext();
    const bnplSpendType = 'BNPL';
    const bnplDeferredInterestSubledgerType = 'BnplDeferredInterest';

    useEffect(() => {
        const checkBNPLDeferredInterestRate = async () => {
            if (accountId) {
                try {
                    const response = await interestService.getAccountEffectiveRates(accountId);
                    const hasBNPLRate = response.rates?.some(
                        (rate) => rate.spendType === bnplSpendType && rate.subledgerType === bnplDeferredInterestSubledgerType
                    );
                    setHasBNPLDeferredInterestRate(hasBNPLRate);
                } catch (error) {
                    setHasBNPLDeferredInterestRate(false);
                }
            }
        };

        checkBNPLDeferredInterestRate();
    }, [accountId, interestService]);

    const onBNPLDeferredInterestClicked = async () => {
        try {
            setBNPLDeferredInterestCreating(true);

            const now = new Date();
            const authorisationDate = new Date(billingDate);
            authorisationDate.setHours(now.getHours());
            authorisationDate.setMinutes(now.getMinutes());
            authorisationDate.setSeconds(now.getSeconds());

            // const description = "Test BNPL DI Authorisation";
            const spendType = "BNPL";
            // const response = await transactionService.authorise(accountId, amount, authorisationDate.toISOString(), description, spendType);

            let offerDetails = null;

            offerDetails = {
                name: "BNPL DI Test",
                termDuration: termDuration,
                interestRate: null,
                offerType: "BNPLDeferredInterest"
            }

            await transactionService.createTransaction({
                accountId, amount,
                balanceMovementType: "Purchase",
                description: "Test BNPL DI Transaction",
                // authorisationId: response.authorizationId, 
                effectiveDate: authorisationDate.toISOString(),
                creditRelease: null,
                externalId: null,
                reason: null,
                spendType: spendType,
                offerDetails
            });


            setBNPLDeferredInterestCreating(false);
        } catch (error) {
            setBNPLDeferredInterestCreating(false);
            setError({ source: 'BNPL Deferred Interest', ...error });
        }
    };

    return (
        <div className="ui card">
            <div className="custom-card-header">Create BNPL Deferred Interest</div>
            <div className="content">
                <div className="ui form">
                    <div className="field">
                        <label>Term Duration</label>
                        <div className="ui labeled input">
                            <div className="ui label">#</div>
                            <select onChange={(e) => setTermDuration(parseInt(e.target.value))}>
                                {termDurations.map(term => (<option key={term} value={term}>{`${term} Months`}</option>))}
                            </select>
                        </div>
                    </div>
                    <div className="field">
                        <label>Amount</label>
                        <div className="ui labeled input">
                            <div className="ui label">£</div>
                            <input
                                type="number"
                                placeholder="Amount"
                                step=".01"
                                disabled={bnplDeferredInterestCreating}
                                onChange={(e) => setAmount(parseFloat(e.target.value))}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {!hasBNPLDeferredInterestRate && (
                <div className="ui negative message">
                    <p>BNPL DI interest rate is not configured for this account.</p>
                </div>
            )}

            <button
                type="button"
                className={`ui primary button ${bnplDeferredInterestCreating && 'loading'}`}
                disabled={ amount <= 0 || !hasBNPLDeferredInterestRate }
                onClick={() => onBNPLDeferredInterestClicked()}>
                Create BNPL
            </button>
        </div>
    );
}